import {useEffect, useState} from "react";
import axios from "axios";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { setAdvertisement } from "../../../../../../redux/slices/videoDataSlice";
import { conditions, getUUID, secondsToPersianHMS, videoTag } from "../../../../../../helpers";
import { ConditionName } from "../../../../../../interfaces";
import { shallowEqual } from 'react-redux'

const AdTimer = () => {
    
    const [previewAdDuration, setPreviewAdDuration] = useState<number>(0);

    const dispatch = useAppDispatch();
    const { ads } = useAppSelector(({ videoData: { ads } }) => ({ ads }), shallowEqual);

    useEffect(() => {
        let id: any = null;
        if (previewAdDuration !== ads.adPreDuration) {
            id = setInterval(() => {
                setPreviewAdDuration(prevState => prevState + 1)
            }, 1000);
        }
        return () => clearInterval(id)
    }, [])

    useEffect(() => {
        if (previewAdDuration === ads.adPreDuration) {
            (async () => {
                try {
                    const uuidObj = {"uuid": getUUID()};
                    const response = await axios({
                        url: ads.progressUrl,
                        method: "get",
                        headers: {},
                        data: uuidObj
                    });
                } catch (error) {
                    console.error(error)
                }
            })()
        } else if (previewAdDuration === ads.adDuration) {
            (async () => {
                try {
                    const uuidObj = {"uuid": getUUID()};
                    const response = await axios({
                        url: ads.completeUrl,
                        method: "get",
                        headers: {},
                        data: uuidObj
                    });
                } catch (error) {
                    console.error(error)
                }
                dispatch(setAdvertisement({...ads, adStreamLink: undefined}))
            })()
        }
    }, [previewAdDuration])

    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (previewAdDuration >= ads.adPreDuration) {
                    (async () => {
                        try {
                            const uuidObj = {"uuid": getUUID()};
                            const response = await axios({
                                url: ads.skipUrl + `?skipTime=${videoTag().currentTime}`,
                                method: "get",
                                headers: {},
                                data: uuidObj
                            });
                        } catch (error) {
                            console.error(error)
                        }
                    })()
                    dispatch(setAdvertisement({...ads, adStreamLink: undefined}))
                }
            }}
            className={`${previewAdDuration >= ads.adPreDuration && "pl-cursor-pointer"} pl-absolute pl-bg-secondary-700/[0.8] pl-rounded-l-[8px] pl-text-white pl-font-[700] pl-right-0 ${conditions(ConditionName.isTouchScreen) ? "pl-text-[12px] pl-bottom-[42px] pl-py-[13px] pl-px-2 pl-h-[48px]" : "pl-text-[16px] pl-bottom-[148px] pl-py-[25px] pl-px-4 pl-h-[72px]"}`}>
            {`رد کردن تبلیغات ${previewAdDuration <= ads.adPreDuration ? secondsToPersianHMS(ads.adPreDuration - previewAdDuration) : ""}`}
        </div>
    )
}

export default AdTimer;